import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import "react-datepicker/dist/react-datepicker.css";
import CardClientTest from "./CardClientTest";
import { SchedulePopoverTest } from "./SchedulerPopOverTest";
import MenuIcon from "@mui/icons-material/Menu";
import SidebarComponent from "../SideBar/sidebar";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import { jwtDecode } from "jwt-decode";

export const appointmentStatuses = {
  FULL: "full",
  AVAILABLE: "available",
  BOOKED: "booked",
};

export const appointmentStatusesProps = {
  FULL: {
    backgroundColor: "#fff",
    title: "Popunjeno",
  },
  AVAILABLE: {
    backgroundColor: "#98C3F2",
    title: "",
  },
  BOOKED: {
    backgroundColor: "#357a38",
    title: "Rezervisano",
  },
};
const SchedulerTest = ({
  startHour = 8,
  endHour = 21,
  handleNavigate,
  selectedDate,
}) => {
  const [appointments, setAppointments] = useState({});
  const [isMyAppointment, setMyAppointment] = useState([]);
  const [isSideBarOpen, setIsSideBarOpen] = useState(null);
  const [clientScheduler, setClientScheduler] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isInRange, setIsInRange] = useState(false);
  const token = localStorage.getItem("token");
  const decoded = token ? jwtDecode(token) : null;

  const [activeClientId, setClientActiveId] = useState(decoded?.id || null);
  const [activeReschedule, setActiveReschedule] = useState(true);
  const [activeClientInformation, setActiveClientInformation] = useState(null);
  const [updateActiveReschedule, setUpdateActiveReschedule] = useState(false);
  const divRef = useRef(null);
  const currentDay = selectedDate.getDay();
  const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay;
  const currentWeekDates = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(selectedDate);
    day.setDate(selectedDate.getDate() + diffToMonday + i);
    if (i !== 6) {
      currentWeekDates.push(day);
    }
  }

  const navigate = useNavigate();

  const realAppointments =
    appointments &&
    Object.values(appointments)
      .filter((appointment) => appointment.checked)
      .filter((value, index, self) => {
        return index === self.findIndex((t) => t.id === value.id);
      });

  const hours = Array.from(
    { length: endHour - startHour + 1 },
    (_, i) => i + startHour
  ).filter((hour) => ![14].includes(hour));

  const handleToggleSidebar = (state, clientId, scheduler) => {
    console.log("usao ove");
    console.log(state, clientId, scheduler, "xdd");

    if (clientScheduler === 0 && clientId && scheduler) {
      setClientScheduler(clientId);
    } else if (state) {
      setIsSideBarOpen(clientId);
      setClientScheduler(0);
    } else {
      setIsSideBarOpen(null);
      setClientScheduler(0);
    }
  };
  const weekDays = ["Pon", "Uto", "Sre", "Čet", "Pet", "Sub"];

  useEffect(() => {
    handleFetchBookings();
    setMyAppointment([]);
  }, [
    selectedDate,
    activeReschedule,
    updateActiveReschedule,
    activeClientInformation,
  ]);

  const handleFetchBookings = async () => {
    const data = {
      client_id: activeClientId,
    };

    const startOfWeek = moment(selectedDate).clone().startOf("week");
    const startDate = startOfWeek.format("YYYY-MM-DD");

    const appointmentsResponse = await ApiMethods.get(
      `auth/bookings_per_client_timeslot?start=${startDate}`
    );

    const myAppointmentsResponse = await ApiMethods.post(
      "auth/client_bookings",
      data
    );

    console.log(appointmentsResponse);

    const tempAppointments = appointmentsResponse.map((appointment) => {
      const tempAppointment = {
        id: appointment.id,
        start: moment
          .parseZone(appointment.start)
          .format("YYYY-MM-DD HH:mm:ss"),
        end: moment.parseZone(appointment.end).format("YYYY-MM-DD HH:mm:ss"),
        max_bookings: appointment.max_bookings,
        used_bookings: appointment.used_bookings,
        free_bookings: appointment.free_bookings,
        bookings_client: appointment.bookings,
        status: null,
        checked: false,
      };

      const isMyAppointment =
        myAppointmentsResponse.findIndex((ma) => ma.id === appointment.id) > -1;

      if (activeReschedule && activeClientId) {
        tempAppointment.bookings_client = appointment.bookings.filter(
          (booking) => booking.client_id === activeClientId
        );
      }

      if (isMyAppointment) {
        tempAppointment.status = appointmentStatuses.BOOKED;
        tempAppointment.backgroundColor =
          appointmentStatusesProps.BOOKED.backgroundColor;
        tempAppointment.title = appointmentStatusesProps.BOOKED.title;
        return tempAppointment;
      }

      if (tempAppointment.free_bookings === 0) {
        tempAppointment.status = appointmentStatuses.FULL;
        tempAppointment.backgroundColor =
          appointmentStatusesProps.FULL.backgroundColor;
        tempAppointment.title = appointmentStatusesProps.FULL.title;
        return tempAppointment;
      }

      tempAppointment.status = appointmentStatuses.AVAILABLE;
      tempAppointment.backgroundColor =
        appointmentStatusesProps.AVAILABLE.backgroundColor;
      tempAppointment.title = appointmentStatusesProps.AVAILABLE.title;
      return tempAppointment;
    });

    const appointmentsObject = tempAppointments.reduce((acc, appointment) => {
      acc[appointment.start] = appointment;
      return acc;
    }, {});

    console.log(appointmentsObject, ":appointmentsObject");

    setAppointments(appointmentsObject);
  };

  useEffect(() => {
    if (isInRange && divRef.current) {
      document.getElementById("divRef").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, [isInRange]);

  useEffect(() => {
    const currentHour = new Date().getHours();
    if (hours.includes(currentHour)) {
      setIsInRange(true);
    }
  }, [hours]);
  const checkCard = (key, id, appointment) => {
    let bookingExistInColumn = false;
    let bookingStateCheckedColumn = false;
    let canceledAppointment = [];

    const date = moment(key).format("YYYY-MM-DD");

    const isChecked = appointments[key].checked;

    if (
      appointment.bookings_client &&
      isChecked &&
      appointment.bookings_client.length > 0
    ) {
      Object.keys(appointments).forEach((key) => {
        if (key.startsWith(date) && appointments[key].id !== id) {
          appointments[key].checked = false;
        }
      });

      appointments[key].checked = !isChecked;

      setAppointments({ ...appointments });

      setMyAppointment((prevAppointments) => {
        if (isChecked) {
          return prevAppointments.filter((appt) => {
            const apptDate = moment(appt.start).format("YYYY-MM-DD");
            const appointmentDate = moment(appointment.start).format(
              "YYYY-MM-DD"
            );
            return appt.id !== appointment.id && apptDate !== appointmentDate;
          });
        } else {
          return [...prevAppointments, appointment];
        }
      });
      return;
    }

    Object.keys(appointments).forEach((key) => {
      if (key.startsWith(date) && appointments[key].id !== id) {
        if (
          appointments[key].bookings_client.length > 0 &&
          appointments[key].bookings_client[0].status !== "noshow"
        ) {
          bookingExistInColumn = true;
          bookingStateCheckedColumn = appointments[key].checked;
          console.log(bookingStateCheckedColumn);
          appointments[key].checked = true;
          canceledAppointment.push(appointments[key]);
        }
        if (appointments[key].bookings_client.length === 0) {
          // console.log("USO SAM3");
          //menjam ovo
          appointments[key].checked = false;
        }
      }
    });

    appointments[key].checked = !isChecked;

    setAppointments({ ...appointments });

    setMyAppointment((prevAppointments) => {
      if (isChecked) {
        return prevAppointments.filter((appt) => appt.id !== appointment.id);
      } else {
        return [
          ...prevAppointments.filter((appt) => appt.id !== appointment.id),
          ...canceledAppointment,
          appointment,
        ];
      }
    });

    console.log(appointments, "Appointment");
  };

  const toggleSidebar = () => {
    console.log("togleSidebnar");
    setIsSidebarOpen(false);
  };
  const logOut = () => {
    console.log("ulazim ovde");
    localStorage.clear();
    navigate("/signinphone", { replace: true });
  };

  const renderTimeSlot = (date, hour) => {
    const startDate = moment(date)
      .hour(hour)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD HH:mm:ss");
    const endDate = moment(date)
      .hour(hour + 1)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD HH:mm:ss");

    const appointment = appointments[startDate];
    // console.log("Appoint: ", appointment);

    const title = appointment ? appointment.title : "";
    const currentTime = moment();
    const isInRange = currentTime.isBetween(startDate, endDate, null, "[)");

    const isPastDayAndHour = moment(startDate)
      .startOf("hour")
      .isBefore(moment().startOf("hour"));
    const backgroundColor = isPastDayAndHour
      ? " rgba(211, 211, 211, 0.5)"
      : appointment && appointment.free_bookings === 0
      ? "#CACACA"
      : isInRange
      ? "#FFEDCA"
      : "#F9F9F9";

    return (
      <div
        key={startDate}
        className="time-slot"
        style={{
          backgroundColor: backgroundColor,
          width: "100%",
          borderRadius: "7px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CardClientTest
          activeClientInformation={activeClientInformation}
          setActiveClientInformation={setActiveClientInformation}
          activeReschedule={activeReschedule}
          setClientActive={setClientActiveId}
          activeClientId={activeClientId}
          isPastDayAndHour={isPastDayAndHour}
          checkCard={checkCard}
          appointment={appointment}
          isSideBarOpen={isSideBarOpen}
          handleToggleSidebar={handleToggleSidebar}
          clientScheduler={clientScheduler}
        />
      </div>
    );
  };

  return (
    <div
      className={`scheduler ${
        activeClientInformation != null && activeClientInformation != undefined
          ? `scheduler-active`
          : ""
      }`}
    >
      <SidebarComponent
        toggleSidebar={toggleSidebar}
        logOut={logOut}
        isOpen={isSidebarOpen}
      />
      <div className="cal-header-row">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "100%",
            alignItems: "center",
          }}
        >
          <IconButton
            style={{
              outline: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setIsSidebarOpen(true);
              console.log(isSidebarOpen);
            }}
          >
            <MenuIcon
              style={{
                display: isSidebarOpen ? "none" : "block",
                cursor: "pointer",
              }}
            />
          </IconButton>
        </div>

        {currentWeekDates.map((date, index) => {
          const isCurrentDate = moment(date).isSame(moment(), "day");
          const hasDatePassed = moment(date).isBefore(moment(), "day");

          return (
            <div
              key={index}
              className="day-header"
              style={{
                backgroundColor: hasDatePassed
                  ? "transparent"
                  : isCurrentDate
                  ? "rgb(255, 237, 202)"
                  : "#f5f5f5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: isCurrentDate ? "7px" : "",
                position: "relative",
              }}
            >
              {index === 0 && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="10"
                  viewBox="0 0 9 10"
                  fill="none"
                  className="arrow-header"
                  style={{
                    position: "absolute",

                    cursor: "pointer",
                  }}
                  onClick={() => handleNavigate("prev")}
                >
                  <path
                    d="M-2.40413e-07 5L8.25 9.76314L8.25 0.236861L-2.40413e-07 5Z"
                    fill="#A9A9A9"
                  />
                </svg>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  className="day-text"
                  style={{ textTransform: "uppercase" }}
                >
                  {weekDays[index]}
                </span>
                <span className="day-number">{date.getDate()}</span>
              </div>
              {index === currentWeekDates.length - 1 && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="10"
                  viewBox="0 0 9 10"
                  fill="none"
                  className="arrow-header-right"
                  style={{
                    position: "absolute",

                    cursor: "pointer",
                  }}
                  onClick={() => handleNavigate("next")}
                >
                  <path
                    d="M9 5L0.75 0.23686L0.75 9.76314L9 5Z"
                    fill="#A9A9A9"
                  />
                </svg>
              )}
            </div>
          );
        })}
      </div>
      <div className="cal-row">
        {hours.map((hour) => {
          const currentHour = new Date().getHours();
          const isCurrentHour = hour === currentHour;

          return (
            <div
              id={isCurrentHour ? "divRef" : ""}
              ref={isCurrentHour ? divRef : null}
              key={hour}
              className={`hour-row ${isCurrentHour ? "current-hour" : ""}`}
              style={{
                backgroundColor: "transparent",
              }}
            >
              <div
                style={{
                  backgroundColor: isCurrentHour
                    ? "rgb(255, 237, 202)"
                    : "#f5f5f5",
                }}
                className="hour time-slot"
              >{`${hour}:00`}</div>
              {currentWeekDates.map((date, dayIndex) => (
                <div style={{ padding: "3px" }} key={dayIndex}>
                  {renderTimeSlot(date, hour)}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <div className="scheduler-mobile">
        <button
          className="scheduler-sidebar-mobile"
          onClick={() => {
            setIsModalVisible(true);
            console.log(isModalVisible, "ISmodalvis");
          }}
        >
          Izabrani termini:{Object.keys(realAppointments).length}
        </button>
      </div>

      {isModalVisible && (
        <SchedulePopoverTest
          setUpdateActiveReschedule={() =>
            setUpdateActiveReschedule(!updateActiveReschedule)
          }
          setModalState={() => setIsModalVisible(false)}
          appointments={isMyAppointment}
        />
      )}
    </div>
  );
};

export default SchedulerTest;
